(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[30818,49105],{

/***/ 88668:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(83369),
    setCacheAdd = __webpack_require__(90619),
    setCacheHas = __webpack_require__(72385);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ 47443:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(42118);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),

/***/ 1196:
/***/ (function(module) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),

/***/ 41848:
/***/ (function(module) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),

/***/ 42118:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(41848),
    baseIsNaN = __webpack_require__(62722),
    strictIndexOf = __webpack_require__(42351);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),

/***/ 62722:
/***/ (function(module) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),

/***/ 45652:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(88668),
    arrayIncludes = __webpack_require__(47443),
    arrayIncludesWith = __webpack_require__(1196),
    cacheHas = __webpack_require__(74757),
    createSet = __webpack_require__(23593),
    setToArray = __webpack_require__(21814);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),

/***/ 74757:
/***/ (function(module) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ 23593:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Set = __webpack_require__(58525),
    noop = __webpack_require__(50308),
    setToArray = __webpack_require__(21814);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),

/***/ 90619:
/***/ (function(module) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ 72385:
/***/ (function(module) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ 21814:
/***/ (function(module) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ 42351:
/***/ (function(module) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),

/***/ 50308:
/***/ (function(module) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),

/***/ 87185:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseUniq = __webpack_require__(45652);

/**
 * This method is like `_.uniq` except that it accepts `comparator` which
 * is invoked to compare elements of `array`. The order of result values is
 * determined by the order they occur in the array.The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.uniqWith(objects, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
 */
function uniqWith(array, comparator) {
  comparator = typeof comparator == 'function' ? comparator : undefined;
  return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
}

module.exports = uniqWith;


/***/ }),

/***/ 49105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Button; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./UI/components/LinkWrapper/index.jsx + 2 modules
var LinkWrapper = __webpack_require__(56362);
// EXTERNAL MODULE: ./UI/components/Button/Button.module.scss
var Button_module = __webpack_require__(20195);
var Button_module_default = /*#__PURE__*/__webpack_require__.n(Button_module);
;// CONCATENATED MODULE: ./UI/components/Button/utils/useButton.js







/* harmony default export */ function useButton(_param) {
    var dark = _param.dark, secondary = _param.secondary, href = _param.href, classes = _param.className, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "dark",
        "secondary",
        "href",
        "className"
    ]);
    var Component = href ? function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, (0,_object_spread/* default */.Z)({}, props));
    } : function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", (0,_object_spread/* default */.Z)({
            type: "button"
        }, props));
    };
    var _obj;
    var className = classnames_default()((Button_module_default()).button, classes, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (Button_module_default()).secondary, secondary), (0,_define_property/* default */.Z)(_obj, (Button_module_default()).dark, dark), _obj));
    return (0,_object_spread/* default */.Z)({
        Component: Component,
        className: className,
        path: href
    }, rest);
};

;// CONCATENATED MODULE: ./UI/components/Button/index.jsx






var Button = function(props) {
    var _ref = useButton(props), Component = _ref.Component, children = _ref.children, restProps = (0,_object_without_properties/* default */.Z)(_ref, [
        "Component",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
Button.propTypes = {
    disabled: (prop_types_default()).bool,
    secondary: (prop_types_default()).bool,
    dark: (prop_types_default()).bool,
    onClick: (prop_types_default()).func,
    href: (prop_types_default()).string
};
/* harmony default export */ var components_Button = (Button);


/***/ }),

/***/ 89628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Forms_DownloadChecklistForm; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./UI/components/Button/index.jsx + 1 modules
var Button = __webpack_require__(49105);
// EXTERNAL MODULE: ./UI/components/TextField/index.jsx + 1 modules
var TextField = __webpack_require__(79228);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./redux/apis/dataSending.js
var dataSending = __webpack_require__(56962);
// EXTERNAL MODULE: ./hooks/usePageClusters.js
var usePageClusters = __webpack_require__(70080);
;// CONCATENATED MODULE: ./UI/components/Forms/DownloadChecklistForm/utils/useProps.js









var useProps = function(_param) {
    var downloadLink = _param.downloadLink, pageSlug = _param.pageSlug, props = (0,_object_without_properties/* default */.Z)(_param, [
        "downloadLink",
        "pageSlug"
    ]);
    var ref;
    var pageClusters = (0,usePageClusters/* default */.Z)();
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,dataSending/* useSubscribeMutation */.iD)({
        fixedCacheKey: dataSending/* SUBSCRIPTION_CASH_KEY */.X3
    }), 2), subscribe = ref1[0], ref2 = ref1[1], data = ref2.data, error = ref2.error, isLoading = ref2.isLoading;
    var message = (data === null || data === void 0 ? void 0 : (ref = data.message) === null || ref === void 0 ? void 0 : ref.data) || (error === null || error === void 0 ? void 0 : error.message) || error;
    var ref3 = (0,index_esm/* useForm */.cI)({
        reValidateMode: "onBlur"
    }), register = ref3.register, handleSubmit = ref3.handleSubmit, reset = ref3.reset, _formState = ref3.formState, touchedFields = _formState.touchedFields, isValid = _formState.isValid, isDirty = _formState.isDirty;
    var handleButtonClick = handleSubmit(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            subscribe((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, values), {
                                pathname: "white_paper_mvp",
                                pageClusters: pageClusters
                            }))
                        ];
                    case 1:
                        _state.sent();
                        if (error) {
                            return [
                                2
                            ];
                        }
                        reset();
                        window.open(downloadLink, "_newtab");
                        return [
                            2
                        ];
                }
            });
        });
        return function(values) {
            return _ref.apply(this, arguments);
        };
    }());
    var isButtonDisabled = !isDirty || isLoading || !isValid;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        register: register,
        touchedFields: touchedFields,
        isButtonDisabled: isButtonDisabled,
        message: message,
        handleButtonClick: handleButtonClick
    });
};
/* harmony default export */ var utils_useProps = (useProps);

// EXTERNAL MODULE: ./UI/components/Forms/DownloadChecklistForm/DownloadChecklistForm.module.scss
var DownloadChecklistForm_module = __webpack_require__(88135);
var DownloadChecklistForm_module_default = /*#__PURE__*/__webpack_require__.n(DownloadChecklistForm_module);
;// CONCATENATED MODULE: ./UI/components/Forms/DownloadChecklistForm/index.jsx






var DownloadChecklistForm = function(props) {
    var ref = utils_useProps(props), register = ref.register, isButtonDisabled = ref.isButtonDisabled, handleButtonClick = ref.handleButtonClick, touchedFields = ref.touchedFields, message = ref.message;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                name: "name",
                register: register,
                placeholder: "Name *",
                errorMessage: "Required field",
                required: touchedFields === null || touchedFields === void 0 ? void 0 : touchedFields.name,
                className: (DownloadChecklistForm_module_default()).input
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                name: "lastName",
                register: register,
                placeholder: "Last Name *",
                errorMessage: "Required field",
                required: touchedFields === null || touchedFields === void 0 ? void 0 : touchedFields.lastName,
                className: (DownloadChecklistForm_module_default()).input
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                name: "email",
                register: register,
                placeholder: "Email *",
                errorMessage: "Incorrect email address",
                required: touchedFields === null || touchedFields === void 0 ? void 0 : touchedFields.email,
                type: "email",
                className: (DownloadChecklistForm_module_default()).input
            }),
            message && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (DownloadChecklistForm_module_default()).message,
                children: message
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                className: (DownloadChecklistForm_module_default()).button,
                disabled: isButtonDisabled,
                onClick: handleButtonClick,
                children: "Download"
            })
        ]
    });
};
DownloadChecklistForm.propTypes = {
    downloadLink: (prop_types_default()).string.isRequired,
    pageSlug: (prop_types_default()).string
};
/* harmony default export */ var Forms_DownloadChecklistForm = (DownloadChecklistForm);


/***/ }),

/***/ 79228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_TextField; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/autosize/dist/autosize.esm.js
var autosize_esm = __webpack_require__(3682);
// EXTERNAL MODULE: ./UI/components/TextField/styles.module.scss
var styles_module = __webpack_require__(91979);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/TextField/utils/useProps.js








/* harmony default export */ function useProps(props) {
    var textarea = props.textarea, style = props.style, classNameProp = props.className, errorMessage = props.errorMessage, attached = props.attached, register = props.register, name = props.name, placeholder = props.placeholder, type = props.type, required = props.required, minLength = props.minLength, maxLength = props.maxLength, rows = props.rows, restProps = (0,_object_without_properties/* default */.Z)(props, [
        "textarea",
        "style",
        "className",
        "errorMessage",
        "attached",
        "register",
        "name",
        "placeholder",
        "type",
        "required",
        "minLength",
        "maxLength",
        "rows"
    ]);
    var Component = textarea ? "textarea" : "input";
    var inputRef = (0,react.useRef)(null);
    var inputRegister = register && register(name, {
        required: required,
        pattern: {
            value: type === "email" && /\S+@\S+\.\S+/
        },
        minLength: minLength,
        maxLength: maxLength
    });
    var _obj;
    var className = classnames_default()(classNameProp, (styles_module_default()).input, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (styles_module_default())[style], style), (0,_define_property/* default */.Z)(_obj, (styles_module_default()).attached, attached), _obj));
    var options = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps, inputRegister), {
        required: required,
        placeholder: placeholder,
        type: type,
        tabIndex: "0",
        rows: rows || 1,
        ref: register ? function(el) {
            inputRegister.ref(el);
            inputRef.current = el;
        } : inputRef
    });
    (0,react.useEffect)(function() {
        if (textarea && inputRef && (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current)) (0,autosize_esm/* default */.Z)(inputRef === null || inputRef === void 0 ? void 0 : inputRef.current);
    }, [
        textarea
    ]);
    return {
        Component: Component,
        className: className,
        options: options,
        errorMessage: errorMessage
    };
};

;// CONCATENATED MODULE: ./UI/components/TextField/index.jsx





var TextField = function(props) {
    var ref = useProps(props), Component = ref.Component, className = ref.className, options = ref.options, errorMessage = ref.errorMessage;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        role: "textbox",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, options)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (styles_module_default()).error,
                tabIndex: "-1",
                children: errorMessage
            })
        ]
    });
};
TextField.defaultProps = {
    type: "text",
    errorMessage: "Fill empty field"
};
TextField.propTypes = {
    register: (prop_types_default()).func,
    onChange: (prop_types_default()).func,
    value: (prop_types_default()).func,
    style: (prop_types_default()).string,
    textarea: (prop_types_default()).bool,
    required: (prop_types_default()).bool,
    type: (prop_types_default()).string,
    name: (prop_types_default()).string,
    placeholder: (prop_types_default()).string.isRequired,
    className: (prop_types_default()).string,
    pattern: (prop_types_default()).string,
    errorMessage: (prop_types_default()).string,
    attached: (prop_types_default()).bool,
    minLength: (prop_types_default()).number,
    maxLength: (prop_types_default()).number
};
/* harmony default export */ var components_TextField = (TextField);


/***/ }),

/***/ 70080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ usePageClusters; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29815);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var redux_apis_blog__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62736);
/* harmony import */ var redux_apis_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85144);
/* harmony import */ var utils_appContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16515);
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6572);






function usePageClusters() {
    var pageFetchQuery = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(utils_appContext__WEBPACK_IMPORTED_MODULE_1__/* .PageFetchContext */ .E).pageFetchQuery;
    var ref = (0,redux_apis_blog__WEBPACK_IMPORTED_MODULE_2__/* .useGetArticleQuery */ .nB)(pageFetchQuery), tmp = ref.data, article = (tmp === void 0 ? {} : tmp).article;
    var ref1 = (0,utils_helper__WEBPACK_IMPORTED_MODULE_3__/* .getDocumentFields */ .OA)(article, [
        "clusters"
    ]), articleClusters = ref1.clusters;
    var ref2 = (0,redux_apis_page__WEBPACK_IMPORTED_MODULE_4__/* .useFetchPageQuery */ .o)(pageFetchQuery), tmp1 = ref2.data, pageData = tmp1 === void 0 ? {} : tmp1;
    var pageClusters = pageData.clusters;
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(articleClusters || []).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(pageClusters || []));
}


/***/ }),

/***/ 85144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ useFetchPageQuery; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6572);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91555);




var pageApi = ___WEBPACK_IMPORTED_MODULE_0__["default"].injectEndpoints({
    endpoints: function(builder) {
        return {
            fetchPage: builder.query({
                extraOptions: {
                    type: ___WEBPACK_IMPORTED_MODULE_0__.BASEQUERY_TYPES.getEntries
                },
                query: function(slug) {
                    return {
                        contentType: "page",
                        additionalQueryParams: {
                            "fields.slug": slug
                        }
                    };
                },
                transformResponse: function transformResponse(response, _, arg) {
                    if (!arg || typeof arg !== "string") {
                        return {
                            data: {}
                        };
                    }
                    var data = response.items[0].fields;
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, data), {
                        metaData: {
                            metaTitle: data.metaTitle || "",
                            metaDescription: data.metaDescription || "",
                            metaRobots: data.metaRobots || "",
                            ogImage: (0,utils_helper__WEBPACK_IMPORTED_MODULE_3__/* .getFileUrl */ .qm)(data.ogImage)
                        }
                    });
                }
            })
        };
    }
});
var useFetchPageQuery = pageApi.useFetchPageQuery;
/* harmony default export */ __webpack_exports__["Z"] = (pageApi);


/***/ }),

/***/ 20195:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__uIelC","secondary":"Button_secondary__2AQtd","dark":"Button_dark__n_Cmy"};

/***/ }),

/***/ 88135:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"DownloadChecklistForm_button__yGfYG","message":"DownloadChecklistForm_message__wQppF","input":"DownloadChecklistForm_input__db8wq"};

/***/ }),

/***/ 91979:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__B8LQP","error":"styles_error__6v2ur","attached":"styles_attached__j_Fm3"};

/***/ })

}]);